import { ArrowRight } from "lucide-react";
import { Link } from "react-router";

import type { DramaSeries } from "~/api/drama";
import { formatCount } from "~/lib/utils";

/** Two links rather than one card-wide link: the poster opens the series, Watch starts it, and an
 *  anchor cannot hold another. */
export function TrendingCard({ series }: { series: DramaSeries }) {
  const id = encodeURIComponent(series.id);

  return (
    <div className="flex w-[148px] shrink-0 flex-col gap-[8px] rounded-[20px] bg-neutral-700 p-[8px] md:w-auto">
      <Link
        id={`cinema-trending-card-${series.id}`}
        to={`/cinema/detail?series=${id}`}
        className="aspect-[2/3] w-full overflow-hidden rounded-[12px] border border-white/10 bg-neutral-800"
      >
        {series.thumbnail && <img src={series.thumbnail} alt="" loading="lazy" className="size-full object-cover" />}
      </Link>
      <Link
        id={`cinema-trending-watch-${series.id}`}
        to={`/cinema/watch?series=${id}`}
        className="flex h-[36px] items-center justify-center gap-[6px] rounded-full border border-white/5 bg-neutral-900 text-[14px] leading-[20px] font-medium text-neutral-50"
      >
        Watch
        <ArrowRight className="size-[14px]" />
      </Link>
      <div>
        <p className="line-clamp-2 text-[14px] leading-[20px] font-semibold text-neutral-50">{series.title}</p>
        {series.viewCount ? (
          <p className="text-[10px] leading-[14px] font-medium text-neutral-500">
            {formatCount(series.viewCount)} watching
          </p>
        ) : null}
      </div>
    </div>
  );
}
